
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"13","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.004 13C15.917 13 20 8.047 20 6.5 20 4.945 15.91 0 10.004 0 4.17 0 0 4.945 0 6.5 0 8.047 4.164 13 10.004 13zm0-1.198C5.18 11.802 1.28 7.569 1.28 6.5c0-.903 3.9-5.302 8.723-5.302 4.8 0 8.715 4.4 8.715 5.302 0 1.07-3.915 5.302-8.715 5.302zm0-1.055c2.276 0 4.105-1.934 4.105-4.247 0-2.374-1.83-4.247-4.105-4.247-2.29 0-4.128 1.873-4.12 4.247.014 2.313 1.83 4.247 4.12 4.247zm0-2.836c-.761 0-1.376-.637-1.376-1.411 0-.781.615-1.41 1.376-1.41.753 0 1.368.629 1.368 1.41 0 .774-.615 1.41-1.368 1.41z","fill":"#888","fill-rule":"nonzero"}})])
          )
        }
      }
    